import { GenericConfig } from '@signature-it/ngx-generic/config';
import { AbstractDTO, RuleDTO, RulesDependFieldsDTO } from '@signature-it/ngx-generic/models';
import { IRulesDependFields } from '@signature-it/ngx-generic/interfaces';
import { EncodeSeoUriPipe } from '@signature-it/ngx-catalogue/pipes';
import { ProductType } from '@signature-it/ngx-catalogue/classes';

export class ProductSolrDTO extends AbstractDTO {

    product_id_i: number;
    product_code_s: string;
    product_name_s:string
    name: string;
    sku: string;
    product_pic_s: string;
    bucket_product_pic_s: string;
    FamilyName_s: string;
    FamilyNameSlug_s: string;
    FamilyName_t: string;
    GroupFamilyName_s: string;
    Name_s: string;
    ProductName_t: string;
    FamilyDesc_t: string;
    FamilyShortDesc_s: string;
    not_buyable_s: string;
    group_id_i: number;
    group_name_s: number;
    group_slug_s: string;
    PricePer_s: string;
    fixed_lot_multiplier_i: number;
    productPageMainTitle: string;
    productPageSecondaryTitle: string;
    productCardMainTitle: string;
    productCardSecondaryTitle: string;
    familyCardMainTitle: string;
    bucketCardMainTitle: string;
    bucketCardSecondaryTitle: string;
    familyCardSecondaryTitle: string;
    cngPageMainTitleField: string;
    cngPageSecondaryTitleField: string;
    ProductName_s: string;
    is_kit_s;
    Seo_Title_t: string;
    Seo_Description_t: string;
    popular_s: string;
    active_status_s: string;
    rules: Array<RuleDTO>;
    rulesDependFields: IRulesDependFields;
	productType: string;
    ProductDescription_s: string;
    productCardProperty1Field: string;
    productCardProperty2Field: string;
    productCardProperty3Field: string;
    productCardProperty4Field: string;
    Price_per_unit_s: string;
    product_cart_details_s: string;
    bucketTotalSkus: number;
    minQtyToOrder: number;
    defaultSku: string;
    promotion: string;
    boxPreviewVar: string;
    linePreviewVar: string;
    taxonomy: string;
    leafNodeUri: string;
    currentNodeUri: string;
    cat: Array<string>;
    cat_id_is: Array<number>;
    productUrl: string;
    Pickup_Only_s: number;
    delivery_only_s: number;
    boxit_only_s: number;
    autoshipment_minimum_amount_s: number;
    autoshipment_s: string;
    autoshipment_text_s: string;
    color_name_ss:  Array<string>;
    color_code_ss:  Array<string>;
    color_price_ss:  Array<string>;
    color_pic_ss:  Array<string>;
    low_price_s:  string;
    always_instock_s: number;
    cat_group_id: number;
    overlayImgUrl: Array<string>;
    overlayClass: Array<string>;
    cngSourceTable: string;
    isCommerceProduct: boolean;

    constructor(attributes?: object) {
        super(attributes);
        attributes = attributes ? attributes : {};

        this.product_id_i = attributes['product_id_i'] || -1;
        this.taxonomy = attributes['taxonomy'] || '';
        this.leafNodeUri = attributes['leafNodeUri'] || (this.taxonomy ? this.calcLeafNodeUri(attributes): '') || '';
        this.cat_group_id = attributes['group_id_s'] || '';
        this.product_code_s = attributes['product_code_s'] || "";
        this.product_name_s = attributes['product_name_s'] || "";
        this.name = attributes['name'] || "";
        this.sku = attributes['sku'];
        this.product_pic_s = attributes['product_pic_s'] || "";
        this.bucket_product_pic_s = attributes['bucket_product_pic_s'] || "";
        this.group_id_i = this.taxonomy ? attributes[`${this.taxonomy}_group_id_i`] : attributes['group_id_i'] || 1;
        this.group_name_s = this.taxonomy ? attributes[`${this.taxonomy}_group_name_s`] : attributes['group_name_s'] || "";
        this.group_slug_s = this.taxonomy ? attributes[`${this.taxonomy}_group_slug_s`] : attributes['group_slug_s'] || "";
        this.cat = this.leafNodeUri && attributes[`${this.taxonomy}_${this.leafNodeUri}_cat_ss`] ? attributes[`${this.taxonomy}_${this.leafNodeUri}_cat_ss`] : (this.taxonomy ? attributes[`${this.taxonomy}_cat_ss`] : attributes['cat'] || []);
        this.cat_id_is = this.leafNodeUri && attributes[`${this.taxonomy}_${this.leafNodeUri}_cat_id_is`] ? attributes[`${this.taxonomy}_${this.leafNodeUri}_cat_id_is`] : (this.taxonomy ? attributes[`${this.taxonomy}_cat_id_is`] : attributes['cat_id_is'] || []);
        this.FamilyName_s = attributes['FamilyName_s'] || "";
        this.FamilyNameSlug_s = attributes['FamilyNameSlug_s'] || "";
        this.FamilyName_t = attributes['FamilyName_t'] || "";
        this.Name_s = attributes['Name_s'] || "";
        this.ProductName_t = attributes['ProductName_t'] || "";
        this.FamilyDesc_t = attributes['FamilyDesc_t'] || "";
        this.FamilyShortDesc_s = attributes['FamilyShortDesc_s'] || "";
        this.not_buyable_s = attributes['not_buyable_s'] || "0";
        this.PricePer_s = attributes['PricePer_s'] || "";
        this.ProductName_s = attributes['ProductName_s'] || "";
        this.fixed_lot_multiplier_i = attributes['fixed_lot_multiplier_i'];
        this.ProductDescription_s = attributes['Product_Description_s'];
        this.productPageMainTitle = GenericConfig.productPageMainTitleField ? attributes[GenericConfig.productPageMainTitleField] : this.ProductName_t;
        this.productPageSecondaryTitle = GenericConfig.productPageSecondaryTitleField ? attributes[GenericConfig.productPageSecondaryTitleField] : this.Name_s;
        this.productCardMainTitle = GenericConfig.productCardMainTitleField ? attributes[GenericConfig.productCardMainTitleField] : this.FamilyName_s;
        this.productCardSecondaryTitle = GenericConfig.productCardSecondaryTitleField ? attributes[GenericConfig.productCardSecondaryTitleField] : this.FamilyShortDesc_s;
        this.familyCardMainTitle = GenericConfig.familyCardMainTitleField ? attributes[GenericConfig.familyCardMainTitleField] : this.FamilyName_s;
        this.familyCardSecondaryTitle = GenericConfig.familyCardSecondaryTitleField ? attributes[GenericConfig.familyCardSecondaryTitleField] : this.FamilyShortDesc_s;
        this.cngPageMainTitleField = GenericConfig.cngPageMainTitleField && attributes[GenericConfig.cngPageMainTitleField] ? attributes[GenericConfig.cngPageMainTitleField] : this.Name_s;
        this.cngPageSecondaryTitleField = GenericConfig.cngPageSecondaryTitleField && attributes[GenericConfig.cngPageSecondaryTitleField] ? attributes[GenericConfig.cngPageSecondaryTitleField] : this.ProductDescription_s;
        this.bucketCardMainTitle = GenericConfig.familyCardMainTitleField ? attributes[GenericConfig.bucketCardMainTitleField] : this.FamilyName_s;
        this.bucketCardSecondaryTitle = GenericConfig.familyCardSecondaryTitleField ? attributes[GenericConfig.bucketCardSecondaryTitleField] : this.FamilyShortDesc_s;
        this.is_kit_s = attributes['is_kit_s'] || 0;
        this.Seo_Title_t = attributes['Seo_Title_t'] || "";
        this.Seo_Description_t = attributes['Seo_Description_t'] || "";
        this.popular_s = attributes['popular_s'] || "";
        this.active_status_s = attributes['active_status_s'] || '';
        this.rules = attributes['rules_lg'] ? RuleDTO.createFromArray(JSON.parse(attributes['rules_lg'])) : [];
        this.rulesDependFields = RulesDependFieldsDTO.create(attributes['rules_depend_fields_lg']);
        this.productType = attributes['product_type_s'] || '';
        this.productCardProperty1Field = GenericConfig.productCardProperty1Field ? attributes[GenericConfig.productCardProperty1Field] : null;
        this.productCardProperty2Field = GenericConfig.productCardProperty2Field ? attributes[GenericConfig.productCardProperty2Field] : null;
        this.productCardProperty3Field = GenericConfig.productCardProperty3Field ? attributes[GenericConfig.productCardProperty3Field] : null;
        this.productCardProperty4Field = GenericConfig.productCardProperty4Field ? attributes[GenericConfig.productCardProperty4Field] : null;
        this.Price_per_unit_s = attributes['Price_per_unit_s'] || "";
        this.product_cart_details_s = attributes['product_cart_details_s'] || "";
        this.bucketTotalSkus = attributes['bucket_total_skus_i'] || 0;
        this.defaultSku = attributes['default_sku_s'] || '';
        this.minQtyToOrder = attributes['min_qty_to_order_s'] || 0;
        this.promotion = attributes['promotion'] || "";
        this.boxPreviewVar = attributes['box_preview_var_s'] || "";
        this.linePreviewVar = attributes['line_preview_var_s'] || "";
        // added for using in product card entity preview template
        this.productUrl = this.getUrl();
        this.Pickup_Only_s = attributes['Pickup_Only_s'] || 0;
        this.delivery_only_s = attributes['delivery_only_s'] || 0;
        this.boxit_only_s = attributes['boxit_only_s'] || 0;
        this.autoshipment_minimum_amount_s = attributes['autoshipment_minimum_amount_s'] || 1;
        this.autoshipment_s = attributes['autoshipment_s'] || 'No';
        this.autoshipment_text_s = attributes['autoshipment_text_s'] || '';
        this.color_name_ss =  attributes['color_name_ss']  ? attributes['color_name_ss'] : [];
        this.color_code_ss =  attributes['color_code_ss'] ?  attributes['color_code_ss'] : [];
        this.color_price_ss =  attributes['color_price_ss'] ?  attributes['color_price_ss'] : [];
        this.color_pic_ss =  attributes['color_pic_ss'] ?  attributes['color_pic_ss'] : [];
        this.low_price_s =  attributes['low_price_s'] ?  attributes['low_price_s'] : '';
        this.always_instock_s =  attributes['always_instock_s'] || 0;
        this.overlayImgUrl =  attributes['overlay_img_url_ss'] || [];
        this.overlayClass =  attributes['overlay_class_ss'] || [];
        this.cngSourceTable = attributes['cng_source_table_s'] || '';
        this.isCommerceProduct = this.cngSourceTable == 'products';
    }


    getUrl() {
	    let productPageUrlField = GenericConfig.productPageUrlField ? GenericConfig.productPageUrlField : 'product_id_i';
        const type = ProductType.getRoute(this.productType || ProductType.Product);
        if (this.taxonomy && this.leafNodeUri) {
            return `/taxonomy/${this.taxonomy}/${this.leafNodeUri}/${type}-page/${this[productPageUrlField]}`;
        }
        if (GenericConfig.disable_friendly_url) {
            return `/${type}-page/${this[productPageUrlField]}`
        }
        const leafGroupName = encodeURIComponent(new EncodeSeoUriPipe().transform(this.group_slug_s));
        const urlField = encodeURIComponent(this[productPageUrlField]);
        return `/${leafGroupName}/${type}-page/${urlField}`;
    }

    calcLeafNodeUri(attributes) {
        const currentNodeuri = attributes['currentNodeUri'];
        let lastFound = '';
        if (currentNodeuri) {
            const currentNode = currentNodeuri.split('/').pop()?.split('?')[0];
            const filteredArrays = this.filterArraysByPattern(attributes, this.taxonomy, '_cat_uri_ss');
            filteredArrays.forEach(array => {
                if (array.includes(currentNode)) {
                    lastFound = array[array.length - 1];
                }
            });
        } else {
            const array = attributes[`${this.taxonomy}_cat_uri_ss`];
            if (array){
                lastFound = array[array.length - 1];
            }
        }
        return lastFound;
     }

    filterArraysByPattern(data, startPattern, endPattern): string[][] {
        return Object.keys(data)
            .filter(key => key.startsWith(startPattern))
            .filter(key => key.endsWith(endPattern))
            .map(key => data[key]);
    }

}
